export default __webpack_public_path__ + "static/media/biztech-white-logo.8fe75993.png";